import { pathOr } from 'ramda';
import { useSportsbookStore } from '../../../../store';

const selectOutcomeById = (outcomeId) => pathOr({}, ['outcomes', outcomeId]);

export const useOutcome = (outcomeId) =>
  useSportsbookStore(selectOutcomeById(outcomeId));
